import { render, staticRenderFns } from "./UsAddressComponent.vue?vue&type=template&id=86968a3c"
import script from "./UsAddressComponent.vue?vue&type=script&lang=js"
export * from "./UsAddressComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../HCP/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports